var map = {
	"./add-icon.svg": 7877,
	"./analytics-icon.svg": 33834,
	"./bookings-icon.svg": 23818,
	"./hamburger-icon.svg": 72249,
	"./home-icon.svg": 86041,
	"./revenue-icon.svg": 9938,
	"./services-icon.svg": 57698,
	"./settings-icon.svg": 85291,
	"./upload-icon.svg": 90239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90310;